@if(loadingSpinner$ | async) {
  <loading-component />
}

<div role="dialog" aria-labelledby="modalAddRemoveTag" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalAddRemoveTag">
          {{ 'attendance.chatScheduleList.listScheduledMessages' | translate }}
          <br>
            <span class="text-muted fw-normal font-14">{{ 'attendance.chatScheduleList.seeAllScheduledMessages' | translate }}</span>
          </h4>
          <button type="button" class="btn-close" [mat-dialog-close]="true" aria-hidden="true"></button>
        </div>
        <div class="modal-body custom-scroll-bar">
          <mat-select class="form-control"
            [(value)]="selectedStatus"
            (selectionChange)="onStatusChange($event)"
            >
            <mat-select-trigger>
              {{ selectedStatus === 'todos' ? 'Todos' : translateStatus(selectedStatus) }}
            </mat-select-trigger>

            <mat-option [value]="'todos'">{{ 'attendance.chatScheduleList.all' | translate }}</mat-option>

            @for(status of statusList; track status) {
              <mat-option [value]="status">
                {{ status === 'todos' ? 'Todos' : translateStatus(status) }}
              </mat-option>
            }
          </mat-select>

          <mat-accordion>
            @for(message of messagesScheduled; track message) {
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header class="w-100 d-flex flex-column justify-content-center justify-content-between align-items-center">
                  <mat-panel-title class="d-flex align-items-center gap-2">
                    <span
                      class="py-1 badge flex-column d-flex gap-1"
                    [ngClass]="{
                      'bg-danger': message.status === 'ERROR',
                      'bg-warning': message.status === 'WAITING',
                      'bg-success': message.status === 'DONE',
                      'bg-dark': message.status === 'MANUAL',
                      'bg-info': message.status !== 'ERROR' && message.status !== 'WAITING' && message.status !== 'DONE' && message.status !== 'MANUAL'
                    }"
                      >

                      {{ translateStatus(message.status) }}

                      @if(message.status === 'MANUAL') {
                        <span class="d-inline-flex align-items-center">
                          <span class="font-10 me-1">{{ message.updatedAt | timezoneDate: 'DD/MM/YYYY': getTimezoneCompanyCurrentUser() }}</span>
                          <span class="font-10"> {{ message.updatedAt | timezoneDate: 'HH:mm': getTimezoneCompanyCurrentUser() }}</span>
                        </span>
                      }
                    </span>

                    @if (message.status === 'ERROR' && message.executionMessage) {
                      <mat-icon
                        class="text-danger cursor-pointer"
                        [matTooltip]="message.executionMessage"
                        [attr.aria-label]="'attendance.chatScheduleList.errorReason' | translate">
                        error_outline
                      </mat-icon>
                    }
                    @if (message.contact?.name) {
                      <p class="p-0 m-0 font-12">{{ message.contact?.name ?? 'Contato' | truncate: 20  }}</p>
                      <p class="p-0 m-0 font-12">{{ message.channel?.name ?? 'Canal' }}</p>
                    }

                    <div class="ms-4">
                      <div class="d-flex justify-content-center align-items-center gap-1">
                        <p class="p-0 m-0 font-12 text-muted">{{ message.scheduledDate | timezoneDate: 'DD/MM/YYYY': getTimezoneCompanyCurrentUser() }}</p>
                        <p class="p-0 m-0 font-12 text-muted">{{ formatTime(message.scheduledTime) }}</p>
                      </div>
                    </div>

                    @if (message.contentType !== 'template' && message.status !== 'DONE' && message.status !== 'MANUAL' && message.status !== 'ERROR') {
                      <mat-icon
                        class="ml-2 cursor-pointer text-warning"
                        [matTooltip]="'attendance.chatScheduleList.sendNow' | translate"
                        (click)="triggerFlashAction(message); $event.stopPropagation()">
                        flash_on
                      </mat-icon>
                    }

                    @if (message.status !== 'DONE' && message.status !== 'MANUAL' && message.status !== 'ERROR') {
                      <mat-icon
                        class="ml-2 cursor-pointer text-primary"
                        [matTooltip]="'attendance.chatScheduleList.edit' | translate"
                        (click)="selectMessageForEdit(message); $event.stopPropagation()">
                        edit
                      </mat-icon>
                    }

                    @if(message.status === 'WAITING') {
                      <mat-icon
                        class="ml-2 cursor-pointer text-primary"
                        [matTooltip]="'attendance.chatScheduleList.delete' | translate"
                        (click)="deleteMessage(message); $event.stopPropagation()">
                        delete
                      </mat-icon>
                    }

                  </mat-panel-title>
                </mat-expansion-panel-header>

                <mat-panel-description>
                  <mat-panel-description>
                    @if (message.type === 'template') {
                      <div class="flex justify-center flex-col bg-[#E5FFFA] shadow-global text-black p-3 rounded-lg">
                        @if (isTemplateMidia(message)) {
                          @if (isTemplateImage(message)) {
                            <div class="flex justify-center flex-col items-center max-w-[300px]">
                              <a data-fancybox="gallery" [href]="message.content">
                                <img [src]="message.content" alt="Image" class="max-w-[600px] w-full object-contain rounded-lg" />
                              </a>
                              <p class="message-text-operator mt-2 break-words items-center w-full"
                                [innerHTML]="getContentTemplateMessage(message)">
                              </p>
                            </div>
                          }
                          @if (isTemplateDocument(message)) {
                            <div class="flex justify-center flex-col items-center max-w-[350px]">
                              <a class="space-x-2 text-black my-2" [href]="message.content" target="_blank">
                                <div class="w-[300px] items-center flex">
                                  <div class="w-[50px]">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
                                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12.75L12 20.25L4.5 12.75" />
                                    </svg>
                                  </div>
                                  <h1 class="mt-2 ml-[10px] w-[300px] items-center">{{ 'attendance.chatScheduleList.clickToOpenDocument' | translate }}</h1>
                                </div>
                              </a>
                              <p class="message-text-operator mt-2 break-words items-center w-full"
                                [innerHTML]="getContentTemplateMessage(message)">
                              </p>
                            </div>
                          }
                          @if (isTemplateVideo(message)) {
                            <div class="flex justify-center flex-col items-center max-w-[300px]">
                              <div class="flex items-center justify-between w-full">
                                <a data-fancybox="gallery" [href]="message.content">
                                  <video width="320" height="240" controls class="rounded-lg">
                                    <source [src]="message.content" type="video/mp4">
                                    {{ 'attendance.chatScheduleList.videoTagNotSupported' | translate }}
                                  </video>
                                </a>
                              </div>
                              <p class="message-text-operator mt-2 break-words items-center w-full"
                                [innerHTML]="getContentTemplateMessage(message)">
                              </p>
                            </div>
                          }
                        } @else {
                          <div>
                            <p class="message-text-operator max-w-[600px] break-words items-center"
                              [innerHTML]="formatWhatsappMessage(message.content)">
                            </p>
                            @if(getTemplateButtons(message).length > 0) {
                              <div>
                                <div class="mt-2 text-sm flex flex-col items-center w-full">
                                  @for (button of getTemplateButtons(message); track button; let i = $index) {
                                    <div class="flex items-center justify-center w-full border-t border-gray-500 py-1">
                                      <mat-icon style="font-size: 16px; color: #000;">reply</mat-icon>
                                      <span class="ml-2">{{ button.text }}</span>
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        }

                        <small style="color: #aaabac !important" class="flex items-end justify-end text-[10px] pt-1">
                          <span class="timestamp">{{message.updatedAt | timezoneDate: 'DD/MM/YYYY HH:mm': getTimezoneCompanyCurrentUser()}}</span>
                        </small>
                      </div>
                    }

                    @if (message.type === 'template') {
                      <div>
                        @if (message.caption || message.contentType?.startsWith('image/') || message.contentType?.startsWith('video/')) {
                          <p class="text-black bg-[#E5FFFA] rounded-lg p-2 shadow-global max-w-[590px] break-words">

                            @if (message.contentType === 'application/pdf') {
                              <ng-container>
                                <div class="flex border border-[#bdbdbd] rounded-lg p-4 mb-4 items-center justify-center">
                                  <mat-icon class="text-black">description</mat-icon>
                                  <p>{{ 'attendance.chatScheduleList.documentAttached' | translate }}</p>
                                </div>
                                <span [innerHTML]="formatWhatsappMessage(message.caption ?? '')"></span>
                              </ng-container>
                            }

                            @if (message.contentType?.startsWith('video/')) {
                              <ng-container>
                                <video controls [src]="message.content ?? ''" class="max-w-[400px] rounded-lg mb-4 m-auto p-2">
                                  {{ 'attendance.chatScheduleList.browserVideoNotSupported' | translate }}
                                </video>
                                <span [innerHTML]="formatWhatsappMessage(message.caption ?? '')"></span>
                              </ng-container>
                            }

                            @if (message.contentType?.startsWith('image/')) {
                              <ng-container>
                                <img [src]="message.content ?? ''" [alt]="'attendance.chatScheduleList.image' | translate" class="max-w-[400px] rounded-lg mb-4 m-auto p-2">
                                <span [innerHTML]="formatWhatsappMessage(message.caption ?? '')"></span>
                              </ng-container>
                            }
                          </p>
                        } @else {
                          <ng-template>
                            @if(message.contentType?.startsWith('text')) {
                              <ng-container>
                                <p class="text-black bg-[#E5FFFA] rounded-lg p-2 shadow-global max-w-[590px] break-words">
                                  <span [innerHTML]="formatWhatsappMessage(message.content ?? '')"></span>
                                </p>
                              </ng-container>
                            }

                            @if (message.content && message.contentType && !message.caption) {
                              @if (message.content && message.contentType && !message.caption) {
                                <ng-container>
                                  @if(message.contentType === 'application/pdf') {
                                    <ng-container>
                                      <div class="flex border border-[#bdbdbd] rounded-lg p-4 mb-4 items-center justify-center">
                                        <mat-icon class="text-black">description</mat-icon>
                                        <p>{{ 'attendance.chatScheduleList.documentAttached' | translate }}</p>
                                      </div>
                                    </ng-container>
                                  }

                                  @if (message.contentType === 'audio/mpeg') {
                                    <ng-container>
                                      <div class="flex border border-[#bdbdbd] rounded-lg p-4 mb-4 items-center justify-center">
                                        <mat-icon class="text-black">audiotrack</mat-icon>
                                        <p>{{ 'attendance.chatScheduleList.audioAttached' | translate }}</p>
                                      </div>
                                    </ng-container>
                                  }

                                  @if (message.contentType?.startsWith('video/')) {
                                    <ng-container>
                                      <video controls [src]="message.content ?? ''" class="max-w-[400px] rounded-lg mb-4 m-auto p-2">
                                        {{ 'attendance.chatScheduleList.browserVideoNotSupported' | translate }}
                                      </video>
                                    </ng-container>
                                  }

                                  @if (message.contentType?.startsWith('image/')) {
                                    <ng-container>
                                      <img [src]="message.content ?? ''" [alt]="'attendance.chatScheduleList.image' | translate" class="max-w-[400px] rounded-lg mb-4 m-auto p-2">
                                    </ng-container>
                                  }

                                </ng-container>
                              }
                            }
                          </ng-template>
                        }

                      </div>
                    }
                  </mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel>
            }
          </mat-accordion>

          @if(!loadingContent && pager.total === 0) {
            <empty-records-legacy-component
              class="d-flex w-100 mt-4 flex-column"
              [message]="'attendance.chatScheduleList.noScheduledMessagesFound' | translate"
              [subMessage]="'attendance.chatScheduleList.changeStatusToSeeMessages' | translate"
              />
          }
        </div>
      </div>
    </div>
  </div>

  @if(pager.total > pager.perPage) {
    <paginator
      class="flex justify-content-center mt-4"
      [pager]="pager"
      (onPager)="loadPage($event)"
      />
  }



